module.exports = __webpack_public_path__ + "media/images/giphy_attribution_black-59b547b1f80e11c805c43dbb50fc3d29.png";